import type { strings } from '@/strings';

/**
 * English, for the shell only.
 *
 * §13 of the design spec puts an English UI out of scope, and it is still out
 * of scope: every page body, every form label and every server refusal message
 * is Arabic and stays Arabic. What is translated here is the frame a person
 * navigates by — the navigation, the user menu, the switchers, the roles — so
 * the switcher does something real rather than nothing.
 *
 * `t()` falls back to the Arabic string for any key absent from this map, so a
 * partially translated interface degrades to Arabic rather than to a raw key.
 * That is deliberate: an untranslated screen in the project's own language is
 * usable, and `signInPhoneLabel` rendered as "signInPhoneLabel" is not.
 */
export const en: Partial<Record<keyof typeof strings, string>> = {
  tagline: 'The competencies platform',

  signOut: 'Sign out',
  userMenuOpen: 'User menu',
  userNoName: 'No name',
  viewSwitch: 'Switch view',
  languageSwitch: 'Language',

  navCollapse: 'Collapse menu',
  navExpand: 'Expand menu',
  navOpen: 'Open menu',
  navClose: 'Close menu',

  roleAdmin: 'Administrator',
  roleRecruiter: 'Recruiter',
  roleRecommender: 'Recommender',
  roleNgoRep: 'Organization contact',
  roleCandidate: 'Candidate',
  roleGuest: 'Guest',

  navAdminOverview: 'Dashboard',
  navAdminUsers: 'Users',
  navAdminTaxonomy: 'Competencies',
  navStaffInvites: 'Invitations',
  navRecruiterQueue: 'Nominations',
  navRecruiterCandidates: 'Candidates',
  navRecruiterOpportunities: 'Opportunities',
  navRecruiterMatches: 'Matching',
  navRecommenderNominate: 'Nominate',
  navRecommenderMine: 'My nominations',
  navOrgAssessment: 'Needs assessment',
  navOrgOpportunities: 'Our opportunities',
  navOrgMatches: 'Candidates',
  navCandidateProfile: 'My profile',
  navCandidateDiagnostic: 'Written diagnostic',
  navCandidateOpportunities: 'Suggested opportunities',
  navGuestRegisterOrg: 'Register an organization',
  orgApprovalsTitle: 'Organization approvals',
  reportsTitle: 'Reports',
};
